<input
  [colorPicker]="value"
  [style.background]="value"
  [cpOutputFormat]="'hex'"
  [cpAlphaChannel]="'disabled'"
  [cpOKButton]="true"
  [cpOKButtonText]="'Select'"
  [cpCancelButton]="true"
  [cpCancelButtonText]="'Cancel'"
  (colorPickerChange)="onColorChange($event)"
  [formControl]="form"
  class="color-picker-input"
  readonly>

<tidy-error-message
  *ngIf="!form.valid && submitted"
  [text]="errorMessage">
</tidy-error-message> 